/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import {  } from "relay-runtime";
export type userTracking_viewer = {
    readonly transactionsCounter?: {
        readonly submittedTransactions?: number | null | undefined;
        readonly confirmedTransactions?: number | null | undefined;
        readonly guestCheckoutTransactions: number | null;
    } | null | undefined;
    readonly " $refType": "userTracking_viewer";
};
export type userTracking_viewer$data = userTracking_viewer;
export type userTracking_viewer$key = {
    readonly " $data"?: userTracking_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"userTracking_viewer">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "checkoutUserId"
        },
        {
            "kind": "RootArgument",
            "name": "hasCheckoutUserId"
        },
        {
            "kind": "RootArgument",
            "name": "hasUserId"
        }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "userTracking_viewer",
    "selections": [
        {
            "condition": "hasCheckoutUserId",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "alias": null,
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "buyerId",
                            "variableName": "checkoutUserId"
                        }
                    ],
                    "concreteType": "TransactionsCounter",
                    "kind": "LinkedField",
                    "name": "transactionsCounter",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "guestCheckoutTransactions",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "guest",
                            "storageKey": null
                        },
                        {
                            "condition": "hasUserId",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "submittedTransactions",
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "submitted",
                                    "storageKey": null
                                },
                                {
                                    "alias": "confirmedTransactions",
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "confirmed",
                                    "storageKey": null
                                }
                            ]
                        }
                    ],
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Viewer",
    "abstractKey": null
} as any;
(node as any).hash = 'ccc2594bb1100b6116146ab8a2ff6863';
export default node;
